export default{props:["close"],computed:{isClose:function isClose(){return this.close}}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/elements/Burger.vue
// module id = 241
// module chunks = 0